import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 21 21",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="m5.803 6.458.7 8.061a1.667 1.667 0 0 0 1.661 1.523h4.861c.864 0 1.585-.661 1.66-1.523l.701-8.06H5.803Zm3.333 2.5v4.584m2.917-4.584v4.584m-3.75-7.084v-.833c0-.92.746-1.667 1.667-1.667h1.25c.92 0 1.666.746 1.666 1.667v.833m-7.916 0h11.25" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />' }
  })
);